export class Annulus {
    id: string;
    wellStringId: string;
    oem: string;
    model: string;
    equipmentBrand: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    status: string;
    remark: string;
    isActuated: boolean;
    // type?: string; // isActuated, true = 'pneumatic' , false = 'manual'
    isAvrInstalled: boolean;
    actuatorModel: string;
    actuatorType: string;
    hydraulicReturn: number;
    openingCm: number;
    closingCm: number;
    openingSec: number;
    closingSec: number;
    fullyOpen: number;
    fullyClose: number;
    jammed: number;
    allowLeakRatePsi10mins: number;
    mdSceValveTypeId: string;
    createdAt: string;

    constructor(initialValues: Partial<Annulus> = {}) {
        Object.assign(this, initialValues);
    }

    reset() {
        const initialValues: Partial<Annulus> = {
            id: '',
            wellStringId: '',
            oem: '',
            model: '',
            sizeIn: 0,
            ratingPsi: 0,
            manufacturer: '',
            partNo: '',
            installedDate: '',
            isActuated: true,
            // type: '',
            isAvrInstalled: false,
            equipmentBrand: '',
            actuatorModel: '',
            actuatorType: 'Pneumatic',
            openingCm: null,
            closingCm: null,
            openingSec: null,
            closingSec: null,
            fullyClose: null,
            fullyOpen: null,
            jammed: null,
            allowLeakRatePsi10mins: null,
            status: '',
            remark: '',
            mdSceValveTypeId: '',
            hydraulicReturn: null,
            createdAt: '',
        };
        Object.assign(this, initialValues);
    }
}